<template>
  <div class="member-code">
    <navbar show-home title="会员码" />
    <div class="member-code-wrapper">
      <div class="member-card">
        <div class="member-info">
          <div class="member-intro">
            <div
              class="meal"
              v-if="userInfo.package && userInfo.package.length"
            >{{userInfo.package[0].offer_name}}</div>
            <div class="meal" v-else>{{userInfo.info.title}}</div>
            <div class="time">有效期至: {{userInfo.exp_at}}</div>
          </div>
        </div>
        <div class="member-code-intro">
          <div class="code-img">
            <img alt v-lazy="QRCode" />
          </div>
          <div class="tips">店内消费时，请向店内服务人员出示此卡</div>
        </div>
      </div>

      <div class="user-intro">
        <div class="title">使用说明</div>
        <p
          class="desc"
        >尊敬的{{userInfo.info.name}}，您可在承接联合会员活动的所有商家店铺内，凭借您的会员码，享受商家提供的打折、直降、赠送等{{userInfo.info.name}}尊享特权。具体活动规则及服务内容以商家活动现场公布为准。</p>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
import { mapState } from 'vuex'
export default {
  components: {
    Navbar
  },
  data () {
    return {
      QRCode: ''
    }
  },
  computed: {
    ...mapState('store', [
      'Authorization',
      'userInfo'
    ])
  },
  created () {
    this.getMemeberCode()
  },
  methods: {
    async getMemeberCode () {
      this.$toast.loading('正在加载...')
      const res = await this.$http('api/public/member/qrcode', { params: { token: this.Authorization } })
      if (res.status === 200) {
        this.$toast.clear()
        const { data, error, msg } = res.data
        if (error === 0) {
          this.QRCode = data
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.member-card {
  width: 100%;
  min-height: 2.78rem;
  padding-top: 0.6rem;
  background: url("../assets/img/member-center/card-bg.png") top no-repeat #fff;
  background-size: 100% 2.78rem;
  .member-code-wrapper {
    padding-top: 0.6rem;
  }
  .member-info {
    margin: 0 auto;
    width: 6.3rem;
    height: 3.2rem;
    background: url("../assets/img/member-center/vip-bg.png") top no-repeat;
    background-size: 100%;
    .member-intro {
      padding-top: 1.8rem;
      padding-left: 0.35rem;
      .meal {
        font-size: @fz26;
        color: #171511;
        font-weight: 500;
        padding-bottom: 0.05rem;
      }
      .time {
        font-size: @fz24;
        color: #66573f;
      }
    }
  }
}
.member-code-intro {
  margin: 0.4rem 0 0.15rem;
  .code-img {
    width: 3.36rem;
    height: 3.36rem;
    margin: 0 auto;
  }
  .tips {
    padding: 0.5rem 0 0.36rem;
    font-weight: bold;
    font-size: @fz34;
    color: #5a5a5a;
    text-align: center;
    background-color: #fff;
  }
}
.user-intro {
  padding: 0.25rem 0.3rem;
  background-color: #fff;

  .title {
    padding-left: 0.3rem;
    text-align: left;
    font-size: @fz32;
    color: @base;
    font-weight: bold;
    border-left: 0.05rem solid #f1c40f;
  }
  .desc {
    padding-top: 0.26rem;
    padding-left: 0.25rem;
    color: #7d7d7d;
    font-size: @fz26;
  }
}
</style>
